class HoverPop extends HTMLElement {
    static get observedAttributes() {
        return [];
    }

    constructor() {
        super();
    }

    connectedCallback() {
        //let tooltipText = this.getAttribute("tooltip")!;
        //let value = this.getAttribute("value")!;
        let backgroundColor = this.getAttribute('background-color') || "#dee";
        //let foregroundColor = this.getAttribute('foreground-color') || "#ff8c00";

        const shadowRoot = this.attachShadow({mode: 'open'});
        shadowRoot.innerHTML = `
            <style>
              .tooltip {
                position: relative;
                display: inline-block;
              }
              
              .tooltip .tooltiptext {
                visibility: hidden;
                min-width:240px;
                background-color: ${backgroundColor};
                text-align: center;
                border-radius: 6px;
                padding: 5px 0;
                position: absolute;
                z-index: 9000;
               
                top:-10px;
                left:50%;
                transform:translate(-50%, -100%);          

                box-sizing:border-box;                
                box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
                border-radius:12px;
              }
              
              .tooltip .tooltiptext::after {
                content: "";
                position: absolute;
                top: 100%;
                left: 50%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: ${backgroundColor} transparent transparent transparent;
              }
              
              .tooltip:hover .tooltiptext {
                visibility: visible;
              }     
            </style>
            <div class="tooltip">
              <slot name="summary"></slot>
              <span class="tooltiptext">                
                <slot name="details"></slot>                
              </span>
            </div>    
                         
        `;
    }
}
customElements.define('hc-hover-pop', HoverPop);